// extracted by mini-css-extract-plugin
export var component = "IframeEmbedContent-module--component--17d25";
export var printImage = "IframeEmbedContent-module--printImage--c6ebd";
export var printImageWrapper = "IframeEmbedContent-module--printImageWrapper--5a0b7";
export var screenEmbed = "IframeEmbedContent-module--screenEmbed--ef84f";